// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const AVATAR_AGE__age_major_AND_age_minor = "%(age_major)s a %(age_minor)s";
export const AVATAR_AGE__EXACTLY_age = "presne %(age)s";
export const number_DAYS = ["%(number)s de\u0148", "%(number)s dni", "%(number)s dn\u00ed"];
export const number_MONTHS = ["%(number)s mesiac", "%(number)s mesiace", "%(number)s mesiacov"];
export const number_WEEKS = ["%(number)s t\u00fd\u017ede\u0148", "%(number)s t\u00fd\u017edne", "%(number)s t\u00fd\u017ed\u0148ov"];
export const number_YEARS = ["%(number)s rok", "%(number)s roky", "%(number)s rokov"];
